import axios from "@/libs/api.request";

export const getAlarmListForNew = (param) => {

  return axios.request({
    url:'/api/api_v2.2.5/alarm/query/queryAll.json',
    data:param,
    method:'post'
  })
}

export const alarmAck = ({id,remarks,alarm_level}) => {

  const data = {
    id, remarks, alarmLevel: alarm_level,
  };
  return axios.request({
    url:'/api/alarm/ack',
    data,
    method:'post',
  })
}

export const alarmRelease = ({id}) => {
  const data = {id}
  return axios.request({
    url: '/api/alarm/release',
    data,
    method: 'post',
  })
}


export const detailAlarm = ({alarm_id}) => {

  const params = {
    alarm_id
  }
  return axios.request({
    url:'/api/20180628/infs/detailAlarm.json',
    params,
    method:'get'
  })
}
/**
 * 清除通知
 */
export const deleteNoticeByUserAndType = (data)=>{
  return axios.request({
    url:'/api/api_v2.3.3/notice/deleteNoticeByUserAndType.json',
    data,
    method:'post'
  })
}






// WEBPACK FOOTER //
// ./src/api/alarmjs.js